export default {
  inject: ['parentvalidator', 'parenttouched'],
  created() {
    this.$validator = this.parentvalidator || this.$validator
    this.touched = this.parenttouched || this.touched
  },
}


// WEBPACK FOOTER //
// ./src/mixins/usesParentValidator.js